import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'
import { selector, useRecoilValueLoadable, atom, useSetRecoilState } from 'recoil'
import entFunctionConfigAtom, { ENT_FUCNTION_CODE_ENUM } from './entFunctionConfigAtom'

type ConfigRes = {
  useWalletAsset: boolean;
  // true 代表该企业开启了邮件发送开关
  receiptEmailSendConfig: boolean;
}

const FETCH_KEY = '/api/entweb/ent/queryInfo'

// 刷新触发器
const refreshTrigger = atom({
  key: `${FETCH_KEY}_refresh_trigger`,
  default: 0,
})

const getData = selector({
  key: FETCH_KEY,
  get: async ({ get }) => {
    get(refreshTrigger)
    const data = await request.get(`${HOSTS.BASE}${FETCH_KEY}`)
    return data as ConfigRes
  },
})

const entInfoAtom = {
  useRefresh: () => {
    const setRefreshTrigger = useSetRecoilState(refreshTrigger)
    return () => {
      setRefreshTrigger(count => count + 1)
    }
  },
  useData: () => {
    const loadable = useRecoilValueLoadable(getData)
    const baseInfo = loadable.state === 'hasValue' ? loadable.contents : null

    // 从企业功能开关接口读取成本中心/费用代码的启用状态
    const functionConfig = entFunctionConfigAtom.useData()
    const costCenterEnabled = functionConfig?.[ENT_FUCNTION_CODE_ENUM.COST_CENTER]?.open ?? false
    const expenseCodeEnabled = functionConfig?.[ENT_FUCNTION_CODE_ENUM.EXPENSE_CODE]?.open ?? false

    if (!baseInfo) return null
    return {
      ...baseInfo,
      costCenterEnabled,
      expenseCodeEnabled,
    }
  },
}

export default entInfoAtom
